import { createContext } from 'react';

const TILE_BOX_SIZE = 25;
const AREA_TILES_WIDTH_NUM = 16;
const AREA_TILES_HEIGHT_NUM = 20;
const BOMBS_COUNT = 50;

export interface TileProps {
  hidden: boolean;
  bomb: boolean;
  bombsNear: number;
  flagged: boolean;
}

export interface GameConfigProps {
  tileSize: number;
  areaTilesWidthNum: number;
  areaTilesHeightNum: number;
  tileBoardWidth: number;
  tileBoardHeight: number;
  currentLevel: 1 | 2 | 3;
  bombCount: number;
  flagCount: number;
  correctCount: number;
  tiles: TileProps[][];
  timer: number;
  started: boolean;
  gameOver: boolean;
  win: boolean;
  reloaded: boolean;
  difficult: 1 | 2 | 3;
  gameTime: number;
}

export interface ICreateTilesProps {
  width: number;
  heigh: number;
  bombs: number;
}

export interface HookProps {
  gameConfig: GameConfigProps;
  setGameConfig: (_: GameConfigProps) => void;
  createTiles: (gameConfigObj?: GameConfigProps) => void;
  showTileByXY: (x: number, y: number, tiles: TileProps[][], deep: number) => { tiles: TileProps[][], gameOver: boolean, flagCount: number } | TileProps[][];
  setFlagged: (x: number, y: number, flag: boolean) => void;
  loadNewGame: () => void;
}

export const defaultGameConfig: GameConfigProps = {
  tileSize: TILE_BOX_SIZE,
  areaTilesWidthNum: AREA_TILES_WIDTH_NUM,
  areaTilesHeightNum: AREA_TILES_HEIGHT_NUM,
  tileBoardWidth: TILE_BOX_SIZE * AREA_TILES_WIDTH_NUM,
  tileBoardHeight: TILE_BOX_SIZE * AREA_TILES_HEIGHT_NUM,
  currentLevel: 1,
  bombCount: BOMBS_COUNT,
  flagCount: 0,
  correctCount: 0,
  tiles: [],
  timer: 0,
  started: false,
  gameOver: false,
  win: false,
  reloaded: false,
  difficult: 1,
  gameTime: 0,
};

const hook: HookProps = {
  gameConfig: defaultGameConfig,
  setGameConfig: _d => void 0,
  createTiles: (gameConfigObj?: GameConfigProps) => void 0,
  showTileByXY: (x: number, y: number, tiles: TileProps[][], deep: number) => { return {tiles: [] as TileProps[][], gameOver: false, flagCount: 0 } as { tiles: TileProps[][], gameOver: boolean, flagCount: number } },
  setFlagged: (x: number, y: number, flag: boolean) => void 0,
  loadNewGame: () => void 0,
};

export default createContext<HookProps>(hook);
